import API from "../API Service/ApiCalls";
import ApiService from "../API Service/ApiService";
import { appConstants } from "../Pages/AppConstants";

var apiService = new ApiService();

class SubflowTemplateServiceController {
  getSubflowTemplateList = async () => {
    try {
      const response = await apiService.getData(API.subflowTemplateAPI, { "clientId": appConstants.clientId });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // Clone the response if you need to log the raw response
      const responseClone = response.clone();
      const json = await response.json();
      return json;
    } catch (error) {
      console.error("Error fetching subflow template list:", error);
      throw error;
    }
  };
  removeDataOnSubflowTemplateList = async (id) => {
    var response = await apiService.postData(API.removeDatafromSubflowTemplate, { 'id': id });
    return response;
  };
  publishSubflowTemplate = async (id, mode) => {
    var response = await apiService.postData(API.publishSubflowTemplate, { "id": id, "mode": mode });
    return response;
  };
  addEditSubflowTemplate = async (requestBody) => {
    var response = await apiService.postData(API.addEditSubflowTemplate, {}, requestBody);
    return response;
  };

  getSubflowTemplateDropdownValuesWorkflow = async () => {
    var response = await apiService.getData(API.workflowDropdownValues, {});
    var json = await response.json();
    return json;
  };
  getSubflowTemplateDropdownValuesLevels = async (id, versionId) => {
    try {
      const response = await apiService.getData(
        API.levelDropdownValues,
        { workflowTemplateId: id, versionId: versionId  }
      );

      if (!response) {
        return { success: false, message: "No response from server" };
      }
      const json = await response.json();
      if (json.Success === false) {
        return null;
      }

      return json;

    } catch (error) {
      console.error("Error fetching dropdown values:", error);
      return { success: false, message: "Something went wrong" };
    }
  };


  getEvents_For_SubflowTemp_Creation_and_Updation = async () => {
    var response = await apiService.getData(API.secondaryEvents, { "clientId": appConstants.clientId, "isPublished": true });
    var json = await response.json();
    return json;
  }

  getPreviewImg = async (id, source) => {
    var response = await apiService.getData(API.previewImage, { "id": id, "source": source });
    //var json = await response.json();
    return response.text();
  }

  getSelectedEventsBySkillLevel = async (levelId) => {
    var response = await apiService.getData(API.getSelectedEventsBySkillLevel, { "levelId": levelId, "clientId": appConstants.clientId, "isPublished": false });
    var json = await response.json();
    return json;
  }
  getAllRoles = async () => {
    var response = await apiService.getData(API.getAllRoles, {});
    var json = await response.json();
    return json;
  }

  getWorkFlowPermissionById = async (workflowId, workflowType, levelId) => {
    var response = await apiService.getData(API.getWorkFlowPermissionById, { "workflowId": workflowId, "workflowType": workflowType, "levelId": levelId });
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }
  getCompletionRulesBySubflowId = async (subworkflowId, eventId) => {
    var response = await apiService.getData(API.getCompletionRulesBySubflowId, { "subworkflowId": subworkflowId, "eventId": eventId });
    if (!response || response.Success === false) {
      return [];
    }
    else {
      var json = await response.json();
      return json;
    }
  }
  postAddUpdateWorkFlowPermission = async (requestBody) => {
    const response = await apiService.postData(API.postAddUpdateWorkFlowPermission, {}, requestBody);
    //var json = await response.json();
    return response;  // ✅ return only JSON
  };

  postAddUpdateSFCompletionRule = async (requestBody) => {
    const response = await apiService.postData(API.postAddUpdateSFCompletionRule, {}, requestBody);
    //var json = await response.json();
    return response;  // ✅ return only JSON
  };
  getVersionTemplateByTemplateId = async (templateId, version) => {
    var response = await apiService.getData(API.getVersionTemplateByTemplateId, { "templateId": templateId, "version": version });
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  };
  getEventWithOrderBy = async (templateId) => {
    var response = await apiService.getData(API.getEventWithOrderBy, { "templateId": templateId});
    if (response === null) {
      return response;
    }
    else {
      var json = await response.json();
      return json;
    }
  }
   getRulesEventRule = async (eventId) => { 
    var response = await apiService.getData(API.getRulesEventRule, { "eventId": eventId });
    var json = await response.json(); 
    return json;
  };
   updateSubFlowOrder = async (requestBody) => {
    const response = await apiService.postData(API.updateSubFlowOrder, {}, requestBody);
    //var json = await response.json();
    return response;  // ✅ return only JSON
  };
}
export default SubflowTemplateServiceController;